import React, { useState, useEffect } from 'react';
import './CartSummary.css'; // Make sure to add relevant styling in this CSS file
import { useNavigate } from "react-router-dom";
import { showtoast } from './Utilities/Utilities';

export const CartSummary = (props) => {
    const { allCartSummary, isTokenValid, reqParams } = props;

    const [finalCart, setFinalCart] = useState({
                                        vouchers: 0,
                                        cartDesc: "",
                                        cartValue: 0,
                                        totalDiscount: 0
                                    });

    const navigate = useNavigate();

    const gotToCustomerInfo = () => {
        if (finalCart.vouchers >= 10 && finalCart.vouchers <= 25) {
            navigate("/customer-info", { state: { finalCart: finalCart, allCartSummary: allCartSummary, isTokenValid:isTokenValid, reqParams: reqParams } });
        }
        else {
            showtoast("error", "Minimum 10 and Maximum 25 vouchers are allowed.");
        }
    }

    useEffect(() => { 
        let totalVoucher = 0;
        let desc = "";
        let totalPrice = 0;
        let totalDiscount = 0;
        let totalAmount = 0;

        if (allCartSummary.length > 0) { 
            allCartSummary.forEach((data) => {
                totalVoucher += data.quantity
                desc = desc.length > 0 ? desc + " + " : "";
                desc = desc + `${data.quantity} ${data.subscriptionPlanName}`;
                totalPrice = data.finalAggrTotal;
                totalDiscount = data.finalAggrTotalDiscount;
                totalAmount = data.totalAggrWithoutDiscount;

                });
            let finalCartsummary = {
                vouchers: totalVoucher,
                cartDesc: desc,
                cartValue: totalPrice,
                totalDiscount: totalDiscount,
                totalAmount: totalAmount
            }
            setFinalCart((prv)=>({ ...prv, ...finalCartsummary }));
        }

    }, [allCartSummary])

    return (
        <>
            <div className="friendsFamily voucher-notification">
                <div className="voucher-info">
                    <p><strong>{finalCart.vouchers} Vouchers Added for Purchase</strong></p>
                    <p>{finalCart.cartDesc} = ₹{finalCart.cartValue}</p>
                </div>
                <div className="view-summary">
                    <button className="summary-btn" onClick={gotToCustomerInfo}>View Order Summary</button>
                </div>
                <div className="close-btn" onClick={() => props.handleCloseCartSummary()}>
                    <img src="/Images/x.png" alt="Close"/>
                </div>
            </div>
        </>
    );
};
 
